import React from 'react';

import { SignupConsumerPageForm } from 'src/components/auth';
import { PositionDetailsModal } from 'src/modals/position';
import { AuthSignupConsumerProvider } from 'src/providers/AuthSignupConsumerProvider';

export const SignupConsumerPage: React.FC = () => {
  return (
    <AuthSignupConsumerProvider>
      <SignupConsumerPageForm />

      <PositionDetailsModal />
    </AuthSignupConsumerProvider>
  );
};
